import EndUserLicenseContent from './subscription-agreement-content.connect.js'

export default EndUserLicenseContent
